import { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Country, State, City } from "country-state-city";
import { useLanguage } from "../context/LanguageContext";


const LocationSelector = ({ onLocationChange, initialValues, disabled=false }) => {
  const { language } = useLanguage();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  
  // Estado para armazenar os códigos ISO
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [selectedStateCode, setSelectedStateCode] = useState("");
  
  // Estado para os nomes exibidos nos selects
  const [selectedCountry, setSelectedCountry] = useState(initialValues?.country || "");
  const [selectedState, setSelectedState] = useState(initialValues?.state || "");
  const [selectedCity, setSelectedCity] = useState(initialValues?.city || "");

  useEffect(() => {
    setCountries(Country.getAllCountries());
  }, []);

  // Efeito para inicializar os valores
  useEffect(() => {
    if (initialValues?.country) {
      const country = countries.find(c => c.name === initialValues.country);
      if (country) {
        setSelectedCountryCode(country.isoCode);
        setSelectedCountry(country.name);
        
        if (initialValues.state) {
          const countryStates = State.getStatesOfCountry(country.isoCode);
          setStates(countryStates);
          
          const state = countryStates.find(s => s.name === initialValues.state);
          if (state) {
            setSelectedStateCode(state.isoCode);
            setSelectedState(state.name);
            
            if (initialValues.city) {
              const stateCities = City.getCitiesOfState(country.isoCode, state.isoCode);
              setCities(stateCities);
              setSelectedCity(initialValues.city);
            }
          }
        }
      }
    }
  }, [countries, initialValues]);

  const handleCountryChange = (e) => {
    const isoCode = e.target.value;
    const country = countries.find(c => c.isoCode === isoCode);
    
    if (country) {
      setSelectedCountryCode(isoCode);
      setSelectedCountry(country.name);
      setStates(State.getStatesOfCountry(isoCode));
      setSelectedStateCode("");
      setSelectedState("");
      setCities([]);
      setSelectedCity("");
      
      onLocationChange({
        country: country.name,
        state: "",
        city: ""
      });
    }
  };

  const handleStateChange = (e) => {
    const isoCode = e.target.value;
    const state = states.find(s => s.isoCode === isoCode);
    
    if (state) {
      setSelectedStateCode(isoCode);
      setSelectedState(state.name);
      setCities(City.getCitiesOfState(selectedCountryCode, isoCode));
      setSelectedCity("");
      
      onLocationChange({
        country: selectedCountry,
        state: state.name,
        city: ""
      });
    }
  };

  const handleCityChange = (e) => {
    const cityName = e.target.value;
    setSelectedCity(cityName);
    
    onLocationChange({
      country: selectedCountry,
      state: selectedState,
      city: cityName
    });
  };

  return (
    <div className="mb-3">      
      <Row>
        <Col md={4}>
          <Form.Group>
            <Form.Label htmlFor="country">{language === "pt" ? "País *" : "Country *"}</Form.Label>
            <Form.Select
              value={selectedCountryCode}
              onChange={handleCountryChange}
              required
              disabled={disabled}
            >
              <option value="">{language === "pt" ? "Select país" : "Select country"}</option>
              {countries.map((country) => (
                <option key={country.isoCode} value={country.isoCode}>
                  {country.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group>
            <Form.Label htmlFor="state">{language === "pt" ? "Província *" : "State *"}</Form.Label>
            <Form.Select
              value={selectedStateCode}
              onChange={handleStateChange}
              disabled={!selectedCountryCode || disabled}
            >
              <option value="">{language === "pt" ? "Selecione uma província" : "Select State"}</option>
              {states.map((state) => (
                <option key={state.isoCode} value={state.isoCode}>
                  {state.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group>
            <Form.Label htmlFor="city">{language === "pt" ? "Distrito" : "City"}</Form.Label>
            <Form.Select
              value={selectedCity}
              onChange={handleCityChange}
              disabled={!selectedStateCode || disabled}
            >
              <option value="">{language === "pt" ? "Selecione um distrito" : "Select City"}</option>
              {cities.map((city, index) => (
                <option key={`${city.name}-${index}`} value={city.name}>
                  {city.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default LocationSelector;